import { Text } from '@/components/base/text'
import type { ConnectorFamilyPinRole } from '@/gql/graphql'

type ConnectorFamilyPin = {
  id: string
  name: string
  role: ConnectorFamilyPinRole
}

type ConnectorPin = {
  id: string
  svg?: string
  connectorFamilyPin: ConnectorFamilyPin
}

interface Props {
  connector: {
    id: string
    name: string
    svg?: string
    connectorPins: ConnectorPin[]
  }
}

export const Connector = ({ connector }: Props) => {
  const identifyPinSvg = (pin: ConnectorPin) => {
    if (pin.svg === undefined) return ''

    return pin.svg.replace('<circle', `<circle id="${connector.id}-${pin.id}"`)
  }

  const buildPinSvgs = () => {
    return connector.connectorPins.reduce((acc, pin) => acc + identifyPinSvg(pin), '')
  }

  const buildSvg = () => {
    if (connector.svg === undefined) return ''

    return connector.svg.replace('</svg>', buildPinSvgs() + '</svg>')
  }

  return (
    <div className="flex flex-col items-center gap-3">
      <div dangerouslySetInnerHTML={{ __html: buildSvg() }} />
      <Text className="font-bold" size="xl">{ connector.name }</Text>
    </div>
  )
}
